import { css } from "lit";
import { Style } from "../Styles";

export const styles = css`
    ${Style}
    .compass {
        position: relative;
        width: var(--compass-width);
        height: var(--compass-height);
        border-radius: 50%;
        box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
        margin: auto;
        background-color: black;
        border-radius: 50%;
        opacity: 89%;
    }

    .start-btn {
        margin-bottom: auto;
    }

    svg {
        width: var(--compass-width);
        height: var(--compass-height);
    }

    #pointer-svg {
        position: absolute;
        top: 0;
        left: 0;
    }
`;
